import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const mainEl = document.getElementById('main');

    if (mainEl) mainEl.scrollTo(0, 0);

    window.scrollTo(0, 0);
  }, [pathname]);
}

export default useScrollToTop;
